import { z } from 'zod';

export const TwinScenarioKind = z.enum([
  'operational-disruption',
  'supply-shock',
  'market-dislocation',
  'regulatory-shift',
  'cyber-incident',
]);

export const TwinScenario = z.object({
  id: z.string(),
  tenantId: z.string(),
  kind: TwinScenarioKind,
  headline: z.string(),
  body: z.string(),
  affectedDimensions: z.array(z.string()),
  severity: z.enum(['advisory', 'warning', 'critical']),
  generatedAt: z.string(),
  generatedByModel: z.string(),
  correlationId: z.string(),
});

export const TwinShadowResult = z.object({
  id: z.string(),
  tenantId: z.string(),
  scenarioId: z.string(),
  testedDecisionRef: z.string(),
  outcome: z.enum(['decision-holds', 'decision-degrades', 'decision-fails']),
  failureModes: z.array(z.string()),
  shadowSyntheticTime: z.number(),
  generatedAt: z.string(),
  correlationId: z.string(),
});
